<script setup>
import { onMounted, ref } from "vue";
import BusinessProfile from "@/components/Business/BusinessProfile.vue";
import Spinner from "@/components/parts/Spinner.vue";
import ButtonComponent from "@/components/Button/ButtonComponent.vue";
import { post } from "@/libs/axios.js";
import { HTTP_PREFIX_PLACEHOLDER } from "@/env.js";
import validateUrl from "@/components/methods/validateUrl.js";

const IMAGE_BASE_LINK = `${window.imgUrl}${window.businessId}/`;

const defaultOrganisation = ref({});
const errors = ref({
    name: "",
    description: "",
    email: "",
    logo: "",
    cover: "",
    website: "",
});

const organisation = ref({});
const fullBusinessData = ref({});

const dataSubmitted = ref(false);

async function getInitData() {
    const res = await post("/get-profile");

    if (res.data.success) {
        const { business, user } = res.data.data;
        defaultOrganisation.value = {
            name: business.name,
            description: business.description,
            website: business.website,
            email: business.email,
            phone: business.phone,
            logo: business.logo_icon_name ? IMAGE_BASE_LINK + business.logo_icon_name : "",
            cover: business.banner_image_name ? IMAGE_BASE_LINK + business.banner_image_name : "",
            firstname: user.firstname,
            lastname: user.lastname,
        };

        fullBusinessData.value = res.data.data?.business;
    }
}

function isInputEmpty(input) {
    return input === "" || input === undefined || input === null;
}

function validateOrganisation() {
    errors.value.name = isInputEmpty(organisation.value.name)
        ? "Enter an organisation name"
        : "";

    errors.value.description = isInputEmpty(organisation.value.description)
        ? "Enter a description"
        : "";

    errors.value.email = isInputEmpty(organisation.value.email)
        ? "Enter an email"
        : "";

    // errors.value.logo = isInputEmpty(organisation.value.logo)
    //     ? "Add logo image"
    //     : "";
    //
    // errors.value.cover = isInputEmpty(organisation.value.cover)
    //     ? "Add cover image"
    //     : "";

    errors.value.firstname = isInputEmpty(organisation.value.firstname)
        ? "Enter first name"
        : "";

    errors.value.lastname = isInputEmpty(organisation.value.lastname)
        ? "Enter last name"
        : "";

    errors.value.website = "";
    if (organisation.value?.website.trim() !== HTTP_PREFIX_PLACEHOLDER) {
        if (validateUrl(organisation.value?.website) !== true) {
            errors.value.website = "Please enter a valid url (including http prefix)";
        }
    }

    return Object.values(errors.value).filter((el) => el !== "").length <= 0;
}

async function submit() {
    const valid = validateOrganisation();

    if (valid && !dataSubmitted.value) {
        if (organisation.value.website.trim() === HTTP_PREFIX_PLACEHOLDER) {
            organisation.value.website = null; // lm - remove we dont wish to store placeholder in DB
        }

        dataSubmitted.value = true;
        const res = await post("/update-profile", { organisation: organisation.value });

        if (res.data.success) {
            window.location.href = `/business/${fullBusinessData.value.slug}?profile-saved=true`;
        } else {
            // eslint-disable-next-line no-alert
            alert("something went wrong saving your profile");
        }
    }

    return true;
}

onMounted(async () => {
    await getInitData();
});

function setOrganisation(data) {
    organisation.value = data;
}
</script>

<template>
    <div class="top-margin profile-page">

        <div class="col-4 mx-auto back-btn-container">
            <a :href="`/business/${fullBusinessData.slug}`" class="back-btn">&lt; Back</a>
        </div>

        <h2 class="col-4 mx-auto">Edit profile</h2>

        <BusinessProfile
            :default-data="defaultOrganisation"
            :errors="errors"
            @updated="setOrganisation"
        />

        <div class="col-4 mx-auto d-flex flex-row justify-content-end mt-4">
            <ButtonComponent
                class="ml-auto"
                @click="submit"
            >
                Save
                <Spinner
                    color="white"
                    v-if="dataSubmitted"
                />
            </ButtonComponent>
        </div>
    </div>
</template>

<style scoped>
.top-margin {
    margin-top: 8rem;
}

.back-btn-container {
    margin-bottom: 3rem;
}

.back-btn {
    color: #260045;
    font-size: 0.9rem;
    line-height: 21px;
    font-weight: 600;
    cursor: pointer;
}

h2 {
    font-weight: 600;
}
</style>
